
export default () => {
    document.addEventListener('DOMContentLoaded', () => {
        const targets = document.querySelectorAll('.reveal');
        if (!targets.length) return;

        const reveal = (el) => {
            // 画像の遅延読み込み（存在する場合だけ）
            const imgs = el.querySelectorAll('img[data-src]');
            imgs.forEach(img => {
                img.src = img.dataset.src;
                img.removeAttribute('data-src');
            });

            // フェードイン
            el.classList.add('is-visible');
        };

        // 古いブラウザは全部出す
        if (!('IntersectionObserver' in window)) {
            targets.forEach(el => reveal(el));
            return;
        }

        const observer = new IntersectionObserver(
            (entries, obs) => {
                entries.forEach(entry => {
                    if (!entry.isIntersecting) return;
                    reveal(entry.target);
                    obs.unobserve(entry.target); // 一回表示したら監視解除
                });
            },
            {
                threshold: 0.1,
                rootMargin: '0px 0px -10% 0px',
                // ↑ 適度に前倒ししたければ調整可
            }
        );

        targets.forEach(el => observer.observe(el));
    });

    // ===== IntersectionObserver =====
    function initReveal() {
        const targets = document.querySelectorAll('.reveal');

        const onReveal = el => {
            // ↓ img遅延ロード
            const imgs = el.querySelectorAll('img[data-src]');
            imgs.forEach(img => {
                img.src = img.dataset.src;
                img.removeAttribute('data-src');
            });

            // ↓ フェードイン
            el.classList.add('is-visible');
        };

        if (!('IntersectionObserver' in window)) {
            targets.forEach(onReveal);
            return;
        }

        const observer = new IntersectionObserver((entries, obs) => {
            entries.forEach(entry => {
                if (!entry.isIntersecting) return;
                onReveal(entry.target);
                obs.unobserve(entry.target);
            });
        }, {
            threshold: 0.1,
            rootMargin: '0px 0px -10% 0px'
        });

        targets.forEach(el => observer.observe(el));
    }
}
